import Icon from '../components/Icon.vue'

Icon.register({
  'window-maximize': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h416zM448 192v-84c0-6.6-5.4-12-12-12h-360c-6.6 0-12 5.4-12 12v84h384z'
      }
    ]
  }
})
